import { render, staticRenderFns } from "./PersonModal.vue?vue&type=template&id=9d3bf8ba&scoped=true"
import script from "./PersonModal.vue?vue&type=script&lang=js"
export * from "./PersonModal.vue?vue&type=script&lang=js"
import style0 from "./PersonModal.vue?vue&type=style&index=0&id=9d3bf8ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3bf8ba",
  null
  
)

export default component.exports